import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { ShareLink } from '#src/app/shared/hooks/share';

import type {
	ContactDecisionMakerSuccessShareLinksQuery,
	ContactDecisionMakerSuccessShareLinksQueryVariables,
} from './api.graphql';
import { ContactDecisionMakerSuccessShareLinks } from './api.graphql';

export async function getContactDecisionMakerSuccessShareLinks({
	id,
	utilityContext,
}: {
	id: string;
	utilityContext: UtilityContext;
}): Promise<readonly ShareLink[]> {
	const { gql } = utilityContext;

	const { data } = await gql.fetch<
		ContactDecisionMakerSuccessShareLinksQuery,
		ContactDecisionMakerSuccessShareLinksQueryVariables
	>({
		query: ContactDecisionMakerSuccessShareLinks,
		variables: { id },
		rejectOnError: true,
	});

	return data.petition?.shareLinks.links ?? [];
}
